module.exports = __webpack_public_path__ + "static/media/roboto-v20-latin-700.adcde98f.woff";